<template>
  <div>
    <my-notification :icon="'thumbs-o-up'">
      <template #title>
        {{ $t('compCarbonDocsThanks.title') }}
      </template>
      <div>
        <span v-html="$t('compCarbonDocsThanks.text-1')" />
        <ul class="bcthanks">
          <li>Tamara Ben Ari : CIRED, Nogent sur Marne</li>
          <li>Olivier Berné : IRAP, Toulouse</li>
          <li>Françoise Berthoud : GRICAD, Grenoble</li>
          <li>Iago Bonnici : LIRMM, Montpellier</li>
          <li>Leila Boubekeur-Lecaque : ITODYS, Paris</li>
          <li>Samuel Calvet : IN2P3, Clérmont-Ferrand</li>
          <li>Julian Carrey : LPCNO, Toulouse</li>
          <li>Maximilien Chaumon : ICM, Paris</li>
          <li>Emmanuel Faure : LIRMM, Montpellier</li>
          <li>Frédéric Héran : CLERSÉ, Lille</li>
          <li>Etienne-Pascal Journet : INRAE, Toulouse</li>
          <li>Sandrine Laguerre : INSA, Toulouse</li>
          <li>Karine Leblanc : MIO, Marseille</li>
          <li>Arthur Leblois : IMN, Bordeaux</li>
          <li>Anne-Laure Ligozat : LIMSI, Orsay</li>
          <li>Maxence Morel : Université Grenoble Alpes, Grenoble</li>
          <li>Sébastien Mustière : COGIT, Saint-Mandé</li>
          <li>Géraldine Sarret : ISTerre, Grenoble</li>
          <li>Jonathan Schaeffer : OSUG, Grenoble</li>
          <li>Xavier Schwindenhammer : Université Grenoble Alpes, Grenoble</li>
          <li>Zhou Xu : Sorbonne Université, Paris</li>
        </ul>
      </div>
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'Thanks',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>

<style lang="css" scoped>
.bcthanks {
  list-style-type: square;
  margin-left: 25px;
}
.bcthanks > li {
  padding-top: 5px;
}
</style>
